<template>
  <div class="search-container bb1">
    <AFormModel layout="inline" class="search-form" size="mini">
      <div class="flex flex-ali-center">
        <div class="flex1 flex flex-ali-center flex-wrap search_box fs14">
          <template v-for="item in searchItem">
            <AFormModelItem :key="item.prop" :label="item.label">
                <template v-if="item.type === 'input' || !item.type">
                  <AInput v-model="searchData[item.prop]" :key="item.prop" :placeholder="item.placeholder"/>
                </template>
                <template v-if="item.type === 'select'">
                  <ASelect v-model="searchData[item.prop]" :key="item.prop" :placeholder="item.placeholder">
                    <ASelectOption v-for="option in item.optionList" :value="option.value" :key="option.value">{{option.label}}</ASelectOption>
                  </ASelect>
                </template>
                <template v-if="item.type === 'daterange'">

                </template>
            </AFormModelItem>
          </template>
        </div>
        <div class="mla pr10">
          <AButton type="primary" icon="search" @click="search">搜索</AButton>
          <AButton class="ml10" icon="redo" @click="reset">重置</AButton>
        </div>
      </div>
    </AFormModel>
  </div>
</template>
<script>
export default {
  props: {
    searchData: {
      type: Object,
      required: true,
    },
    searchItem: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
  },
  methods: {
    search(reset) {
      this.$emit("search", reset == true)
    },
    reset() {
      Object.keys(this.searchData).forEach(key => {
        this.searchData[key] = null
      })
      this.search(true)
    },
  },
};
</script>

<style lang="less" scope>
.search-container{
  // padding: 5px 10px;
  .search-form{
    .ant-form-item{
      margin-left: 20px;
      margin-right: 0px;
    }
  }
}
</style>
